/**
 * European Instance Configuration
 * Controls features for the European server/database instance
 */

export default {
  code: 'EU',
  name: 'Europe',
  app_url: 'https://takso.ideaconsult.be',
  // Feature flags
  withCultureCounts: false,
  // Language settings
  dfltLanguage: import.meta.env.REACT_APP_I18N_DFLT_LANG || 'nl',
  fixedLanguage:
    typeof import.meta.env.REACT_APP_I18N_FIXED_LANG === 'undefined'
      ? false
      : ['true', '1'].includes(
          import.meta.env.REACT_APP_I18N_FIXED_LANG.toLowerCase()
        ),
  // Instance settings
  contactEmail: 'takso.helpdesk@ideaconsult.be',
  contactEmail2: 'takso.helpdesk@ideaconsult.be',
  defaultCountryCode: 'NL',
  defaultCurrencyTypeId: 3, // EUR {euro}
  // TODO:i18n above should be enough - but would need to load currencies from db etc etc
  defaultCurrencyCode: 'EUR',
  // Validation rules - General European phone format
  validation: {
    // Accepts most European phone formats: +XX XXX XXX XXX or 0X XXX XXX XXX
    // Flexible to accommodate different EU countries (BE, NL, FR, DE, etc.)
    phoneRegex:
      /^(\+?[1-9]\d{1,3})?[\s.-]?\(?\d{1,4}\)?[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/,
    phoneFormat: '+XX XXX XXX XXX or 0X XXX XXX XXX',
    phoneMinLength: 8,
    phoneMaxLength: 15,
  },
};
